import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { clone, findIndex, propEq } from 'ramda'

import CardsActions, { CardsRedux, CardsTypes } from '../Redux/CardsRedux'
import ChildrenActions from '../Redux/ParentPlatform/ChildrenRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const cardsCrudObservable = createCRUDObservable({
  mainRedux: CardsRedux,
  reduxPath: 'cards',
  dataHandlers: {
    get: (response) => {
      const authorizedCards = response.data.authorized
      if (authorizedCards.length === 0) {
        return response.data
      }
      const activeCardIndex = findIndex(propEq('is_default', true))(authorizedCards)
      if (activeCardIndex < 0) {
        return response.data
      }
      const activeCard = authorizedCards[activeCardIndex]
      authorizedCards.splice(activeCardIndex, 1)
      authorizedCards.unshift(activeCard)
      response.data.authorized = authorizedCards
      return response.data
    },
  },
})

const createEpic = (action$, store, { Api }) => (
  action$.ofType(CardsTypes.createCardRequest)
    .mergeMap(({ student_id, parent_id, card_info, fromParent }) => (
      Observable
        .fromPromise(Api.cards
          .create(student_id, parent_id, card_info)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              CardsActions.createCardError(response.error),
              notificationFail('Proceso fallido'),
            ]
          }

          const newCard = response.data.data
          const cardsArr = clone(store.getState().cards.get.results)

          if (!fromParent) {
            const authorizedCards = cardsArr.authorized

            if (newCard.is_default && authorizedCards.length) {
              const defaultCardIndex = authorizedCards.findIndex(card => card.is_default)

              if (authorizedCards.length > 0 && defaultCardIndex >= 0) {
                cardsArr.authorized[defaultCardIndex].is_default = false
              }

              // Prepend the card to the array of authorized cards
              cardsArr.authorized.unshift(newCard)
            } else {
              cardsArr.authorized.push(newCard)
            }
          }

          const responses = [
            CardsActions.createCardSuccess(cardsArr),
            notificationSuccess('Actualización exitosa'),
          ]

          if (fromParent) {
            responses.push(ChildrenActions.updateCards(student_id, newCard))
          }

          return responses
        })
    ))
)

const authorizeEpic = (action$, store, { Api }) => (
  action$.ofType(CardsTypes.authorizeRequest)
    .mergeMap(({ student_id, card_id, fromParent }) => (
      Observable
        .fromPromise(Api.cards
          .authorize(student_id, card_id)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              CardsActions.authorizeError(response.error),
              notificationFail('Proceso fallido'),
            ]
          }
          if (!fromParent) {
            return [
              CardsActions.authorizeSuccess(card_id, response.data.data),
              notificationSuccess('Actualización exitosa'),
            ]
          }
          return [
            ChildrenActions.authorizeSuccess(card_id, response.data.data),
            notificationSuccess('Actualización exitosa'),
          ]
        })
    ))
)

const unauthorizeEpic = (action$, store, { Api }) => (
  action$.ofType(CardsTypes.unauthorizeRequest)
    .mergeMap(({ student_id, card_id, fromParent }) => (
      Observable
        .fromPromise(Api.cards
          .unauthorize(student_id, card_id)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              CardsActions.unauthorizeError(response.error),
              notificationFail('Proceso fallido'),
            ]
          }
          if (!fromParent) {
            return [
              CardsActions.unauthorizeSuccess(card_id, response.data.data),
              notificationSuccess('Actualización exitosa'),
            ]
          }
          return [
            ChildrenActions.unauthorizeSuccess(card_id, response.data.data),
            notificationSuccess('Actualización exitosa'),
          ]
        })
    ))
)

const activateEpic = (action$, store, { Api }) => (
  action$.ofType(CardsTypes.activateRequest)
    .mergeMap(({ student_id, card_id, fromParent }) => (
      Observable
        .fromPromise(Api.cards
          .activate(student_id, card_id)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              CardsActions.activateError(response.error),
              notificationFail('Proceso fallido'),
            ]
          }
          if (!fromParent) {
            return [
              CardsActions.activateSuccess(card_id),
              notificationSuccess('Actualización exitosa'),
            ]
          }
          return [
            ChildrenActions.activateSuccess(card_id, response.data.data),
            notificationSuccess('Actualización exitosa'),
          ]
        })
    ))
)

const deleteEpic = (action$, store, { Api }) => (
  action$.ofType(CardsTypes.deleteRequest)
    .mergeMap(({ card_id, fromParent }) => (
      Observable
        .fromPromise(Api.cards
          .delete(card_id)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              CardsActions.deleteError(response.error),
              notificationFail('Proceso fallido'),
            ]
          }
          if (!fromParent) {
            return [
              CardsActions.deleteSuccess(card_id),
              notificationSuccess('Actualización exitosa'),
            ]
          }
          return [
            ChildrenActions.deleteCards(card_id, response.data.data),
            notificationSuccess('Actualización exitosa'),
          ]
        })
    ))
)
export const cardsEpicObservers = Object.assign({}, cardsCrudObservable.observers, {})

export const cardsEpic = combineEpics(
  cardsCrudObservable.epic,
  authorizeEpic,
  unauthorizeEpic,
  activateEpic,
  deleteEpic,
  createEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CardsObserver.js